import type { PropertyNode, ValueNode } from 'json-to-ast';

export function getAstForJsonPointer(
  ast: ValueNode,
  pointer: string[]
): { value: ValueNode; property?: PropertyNode } {
  let currentValue: ValueNode = ast;
  let currentProperty: PropertyNode | undefined;
  pointer.forEach(token => {
    if (!currentValue) {
      throw new Error('Invalid reference: ' + pointer.join('/'));
    }
    if (currentValue.type === 'Literal') {
      throw new Error('Invalid reference token: ' + token);
    } else if (currentValue.type === 'Array') {
      const maybeCurrent = currentValue.children[parseInt(token, 10)];
      if (!maybeCurrent) {
        throw new Error('Invalid reference token: ' + token);
      }
      currentValue = maybeCurrent;
      currentProperty = undefined;
    } else if (currentValue.type === 'Object') {
      const maybeProperty = currentValue.children.find(child => child.key.value === token);
      if (!maybeProperty) {
        throw new Error('Invalid reference token: ' + token);
      }
      currentValue = maybeProperty.value;
      currentProperty = maybeProperty;
    }
  });
  return { value: currentValue, property: currentProperty };
}
